import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const SET_MEDIA_SERVICE_CONFIG = 'SET_MEDIA_SERVICE_CONFIG';
export const SET_MEDIA_SERVICE_LOADING = 'SET_MEDIA_SERVICE_LOADING';
export const SET_MEDIA_SERVICE_ERROR = 'SET_MEDIA_SERVICE_ERROR';
export const SET_MEDIA_SERVICE_VALIDATION = 'SET_MEDIA_SERVICE_VALIDATION';

export const setMediaServiceConfig = (data) => ({ type: SET_MEDIA_SERVICE_CONFIG, payload: data });
export const setMediaServiceLoading = (v) => ({ type: SET_MEDIA_SERVICE_LOADING, payload: v });
export const setMediaServiceError = (e) => ({ type: SET_MEDIA_SERVICE_ERROR, payload: e });
export const setMediaServiceValidation = (r) => ({ type: SET_MEDIA_SERVICE_VALIDATION, payload: r });

export const getMediaServiceConfig = () => (dispatch) => {
  dispatch(setMediaServiceLoading(true));
  return axios
    .get(`${API_BASE_URL}/api/media-service/config`)
    .then((response) => {
      dispatch(setMediaServiceConfig(response.data));
      dispatch(setMediaServiceLoading(false));
      return response.data;
    })
    .catch((err) => {
      dispatch(setMediaServiceLoading(false));
      const msg = err.response?.data?.message || err.response?.data?.error || 'Failed to load media service configuration';
      dispatch(setMediaServiceError(msg));
      throw err;
    });
};

export const updateMediaServiceConfig = (config) => (dispatch) => {
  dispatch(setMediaServiceLoading(true));
  return axios
    .put(`${API_BASE_URL}/api/media-service/config`, config)
    .then((response) => {
      dispatch(showMessage({ message: 'Media service configuration updated' }));
      dispatch(setMediaServiceConfig(response.data));
      dispatch(setMediaServiceLoading(false));
      return response.data;
    })
    .catch((err) => {
      dispatch(setMediaServiceLoading(false));
      const msg = err.response?.data?.message || err.response?.data?.error || 'Failed to update media service configuration';
      dispatch(showMessage({ message: msg, variant: 'error' }));
      dispatch(setMediaServiceError(msg));
      throw err;
    });
};

export const validateMediaService = (body = {}) => (dispatch) => {
  dispatch(setMediaServiceValidation({ loading: true, valid: null, version: null, error: null }));
  return axios
    .post(`${API_BASE_URL}/api/media-service/validate`, body)
    .then((response) => {
      const data = response.data || {};
      dispatch(setMediaServiceValidation({
        loading: false,
        valid: !!data.valid,
        version: data.version || null,
        error: data.valid ? null : (data.error || 'unknown')
      }));
      dispatch(showMessage({
        message: data.valid
          ? `Media service reachable (version ${data.version || 'unknown'})`
          : `Media service unreachable: ${data.error || 'unknown'}`,
        variant: data.valid ? 'success' : 'error'
      }));
      return data;
    })
    .catch((err) => {
      const data = err.response?.data || {};
      dispatch(setMediaServiceValidation({
        loading: false,
        valid: false,
        version: null,
        error: data.error || err.message || 'request_failed'
      }));
      dispatch(showMessage({
        message: `Test failed: ${data.error || err.message || 'unknown'}`,
        variant: 'error'
      }));
      throw err;
    });
};

export const getMediaServiceStatus = () => (dispatch) => {
  return axios
    .get(`${API_BASE_URL}/api/media-service/status`)
    .then((response) => {
      dispatch(setMediaServiceConfig({
        ...response.data,
        url: null,
        hasApiKey: response.data.configured,
        lastHealthCheck: null,
        configuredAt: null,
        configuredBy: null
      }));
      return response.data;
    })
    .catch(() => {
      // Silent: anyone authenticated can read /status; failure means unauthenticated.
    });
};
